import { useState } from "react";

import { cn } from "@/utils/core/generalUtils";

interface ImageWithLoaderProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  classes?: {
    imgClassName?: string;
  };
  loaderNode?: JSX.Element;
}

const ImageWithLoader = ({
  src,
  classes,
  loaderNode,
  ...props
}: ImageWithLoaderProps): JSX.Element => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const renderLoader = (): JSX.Element => {
    if (loaderNode) {
      return loaderNode;
    }

    return (
      <div className='absolute inset-0 flex items-center justify-center bg-gray-200 animate-pulse rounded-sm'>
        <div className='w-4 h-4 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin' />
      </div>
    );
  };

  return (
    <div className='relative'>
      {isLoading && renderLoader()}
      <img
        src={src}
        alt='image'
        className={cn(
          "object-cover w-auto h-auto rounded-sm cursor-pointer",
          classes?.imgClassName,
          isLoading
            ? "opacity-0"
            : "opacity-100 transition-opacity duration-300",
        )}
        loading='lazy'
        onLoad={() => setIsLoading(false)}
        onError={() => {
          setIsLoading(false);
          setIsError(true);
        }}
        {...props}
      />
      {isError && (
        <div className='absolute inset-0 flex items-center justify-center bg-gray-100 rounded-sm'>
          <span className='text-xs text-gray-500'>❌</span>
        </div>
      )}
    </div>
  );
};

export default ImageWithLoader;
